/// <reference path="calendaraccessibility.js" />

import { keyboardTrapFocusOnContainer } from '../helper';


// Room Booking Menu
window.APP = window.APP || {};
import jQuery from 'jquery';

APP.roomBooking = (function ($) {
    'use strict';

    var init = function () {
        var currentPosition;

        $('.js-room-button').each(function (btn) {
            $(this).on('click', function (ev) {
                ev.preventDefault();
                currentPosition = $(document).scrollTop();
                $('body').addClass('booking-menu-is-open');

                // get distance to top
                var distToTop = document.documentElement.scrollTop || document.body.scrollTop;
                // set document to that distance on click
                // document.documentElement.scrollTop = document.body.scrollTop = distToTop;

                $(document).scrollTop();

                // currently a fixed property
                //roomMenu.url[0].chainId = this.dataset.chainId;

              

                //if (window.site == "emory") {
                //    document.querySelector('html').classList.add('booking-menu-active');
                //}


                if (this.dataset.hotelId) {
                    // show menu wrapper
               
                    $('.booking-menu').removeClass('booking-menu--hideAccessibility').addClass('booking-menu--open').removeClass('booking-menu--close');
                    $('body').addClass('booking-menu-is-open');
                
                    // show room booking
                    $('#room-booking').removeClass('hide');
                    // ensure restraunt and hotel menu hidden
                    $('#restaurant-booking').addClass('hide');
                    $('.booking-menu-tabs').removeClass('hide');

                    $('#hotel-menu').addClass('hide');

                    setTimeout(function () {
                        $('body').addClass('overflow-hidden');
                        //$('body').addClass('fixed-position');
                        //$('.js-booking-close').trigger('focus');
                    }, 1000);

                } else {
                    // show menu wrapper
                    $('.booking-menu').removeClass('booking-menu--hideAccessibility').addClass('booking-menu--open').removeClass('booking-menu--close');
                    // how hotel menu
                    $('#hotel-menu').removeClass('hide');
                    // ensure restraunt and room booking hidden

                    $('#restaurant-booking').addClass('hide');
                    $('#room-booking').addClass('hide');
                    $('.booking-menu-tabs').addClass('hide');

                    $('body').removeClass('overflow-hidden');
                    //$('body').removeClass('fixed-position');
                   // $('body').removeClass('booking-menu-is-open');
                }
         
                

                if ($('body').hasClass('maybourne')) {
                    if ($('.booking-menu--open').length) {
                        setTimeout(function () {
                            $('body').addClass('overflow-hidden');
                            //$('body').addClass('fixed-position');
                        }, 1000);
                        $('body').addClass('booking-menu-is-open');
                    }
                    else {
                        $('body').removeClass('overflow-hidden');
                        //$('body').removeClass('fixed-position');
                        $('body').removeClass('booking-menu-is-open');
                    }
                }                           
            });

            this.addEventListener('keydown', (event) => {       
                if (event.key === 'Enter' ) {
                    setTimeout(() => {
                        const focusBtn = document.querySelector('.booking-menu__header .js-booking-close');
                        focusBtn.focus();

                        keyboardTrapFocusOnContainer(event, '.booking-menu');
                    }, 500);
                }
            });

            $('.room-booking__calendar').find('.ui-datepicker-days-cell-over').removeClass('ui-datepicker-current-day');
        });

        $('.js-booking-close').on('click', function (event) {
            closeRoomBookingPopup();

            if (window['scrolInstance']) {
                window['scrolInstance'].start();
            }
        });

        $('.js-booking-close').on('keydown', function (event) {
            // If the user closed the menu with a keyboard action, we want to refocus the open button otherwise it will reset to off the page
            if (event.key && event.key == "Enter") {
                closeRoomBookingPopup();

                setTimeout(() => {
                    document.querySelector('.header .header__right .js-room-button')?.focus();
                }, 500);
            }

            if (window['scrolInstance']) {
                window['scrolInstance'].start();
            }
        });
        
        $(document).on('keydown', function (event) {
         
            if (event.keyCode == 27 && $('.booking-menu--open').length ) {
         
                closeRoomBookingPopup();
                $('.js-room-button').focus(); 
            }
        });

        function closeRoomBookingPopup() {
            $('.booking-menu').addClass('booking-menu--close').removeClass('booking-menu--open');

            setTimeout(function () {
                $('.booking-menu').addClass('booking-menu--hideAccessibility');
            }, 1000);

            $('body').removeClass('overflow-hidden');
            //$('body').removeClass('fixed-position')
            $('body').removeClass('booking-menu-is-open');

            var TAB_BODY = '.booking-menu-tabs__body';
            var TAB_CHILD_FADE = 'fade-children';
            var ACTIVE_SELECTOR = '.is-active';

            $(TAB_BODY + ACTIVE_SELECTOR).removeClass(TAB_CHILD_FADE);
        }
    };

    return {
        init: init
    };

})(jQuery);